import axios from 'axios';

const headers = { Authorization: `Bearer ${localStorage.getItem('USER_TOKEN')}` };

export const getRewardPostbacks = async (params = {}) => {
    const { data } = await axios.get('/api/v1/reward-postbacks', { headers, params });
    return data.data;
};
